module.exports = __webpack_public_path__ + "img/jiamengMain.46abee4a.png";